<div class="history-container">
    <div class="history-header">
        <h4 class="history-title">
            <mat-icon>history</mat-icon>
            Previous Fetches
        </h4>
        <button mat-icon-button (click)="load()" [disabled]="isLoading()" matTooltip="Refresh">
            <mat-icon [class.spinning]="isLoading()">refresh</mat-icon>
        </button>
    </div>

    @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (!isLoading() && fetches().length === 0) {
    <p class="empty-hint">No previous fetches found.</p>
    }

    @if (fetches().length > 0) {
    <div class="fetch-list">
        @for (fetch of fetches(); track fetch.id) {
        <div class="fetch-item" [class.selected]="fetch.id === selectedFetchId"
            [class.selectable]="fetch.status === FetchStatus.Completed" (click)="select(fetch)">
            <div class="fetch-item-left">
                <mat-chip [color]="getStatusColor(fetch.status)" highlighted class="status-chip">
                    <mat-icon matChipAvatar>{{ getStatusIcon(fetch.status) }}</mat-icon>
                    {{ fetch.status }}
                </mat-chip>
                <div class="fetch-meta">
                    <span class="fetch-range">
                        {{ formatEpoch(fetch.timeRangeStart) }} &rarr; {{ formatEpoch(fetch.timeRangeEnd) }}
                    </span>
                    <span class="fetch-created">Requested: {{ fetch.createdAt | date:'short' }}</span>
                </div>
            </div>
            <div class="fetch-item-right">
                @if (fetch.recordCount != null) {
                <span class="record-count" matTooltip="Records fetched">
                    <mat-icon>list_alt</mat-icon>{{ fetch.recordCount }}
                </span>
                }
                @if (fetch.id === selectedFetchId) {
                <mat-icon class="selected-icon">visibility</mat-icon>
                }
            </div>
        </div>
        }
    </div>
    }
</div>